<template>
  <cv-header-menu aria-label="Movimenti" title="Movimenti" v-bind:hover-toggle="autoapertura">
    <cv-header-menu-item href="/#/acquisti">Acquisti - Spese</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-acquisti">Ricerche Acquisti</cv-header-menu-item>
    <hr/>
    <cv-header-menu-item href="/#/utilizzo-materiali">Utilizzo di Materiali</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-utilizzo">Ricerche Utilizzo</cv-header-menu-item>
    <hr/>
    <cv-header-menu-item href="/#/macchine">Macchine</cv-header-menu-item>
    <hr/>
    <cv-header-menu-item href="/#/materiali">Materiali</cv-header-menu-item>
    <cv-header-menu-item href="/#/ricerca-materiali">Ricerca Materiali</cv-header-menu-item>
  </cv-header-menu>
</template>

<script>
export default {
  name: "MenuMovimenti",
  props: {
    autoapertura: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
hr {
  width: 11em;
  border-width: thin;
}
</style>